import { TEST_IDS } from "@/testIds";

const HORIZONS = [3, 6, 9, 12, 18, 24];

/**
 * Horizon selector pill row. The selected month range is displayed
 * prominently by the PageShell banner below the page title, so we only need
 * the compact pill row here.
 */
export default function HorizonSelector({ value, onChange }) {
  return (
    <div
      className="inline-flex items-center gap-1 p-1 bg-surface rounded-full"
      style={{ boxShadow: "0 1px 2px rgba(18,49,89,0.05), 0 6px 16px rgba(18,49,89,0.06)" }}
    >
      {HORIZONS.map((h) => {
        const active = value === h;
        return (
          <button
            key={h}
            data-testid={TEST_IDS.horizonChip(h)}
            onClick={() => onChange(h)}
            className={`cf-touch px-3.5 py-1.5 rounded-full text-xs font-semibold tracking-wide transition-colors duration-150 ${
              active ? "bg-ink text-paper" : "text-muted-dark hover:text-ink"
            }`}
          >
            {h}m
          </button>
        );
      })}
    </div>
  );
}
